/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Sales_Return_Err_Packaging_QtyInputs */

const vi_sales_return_err_packaging_qty = /** @type {(inputs: Sales_Return_Err_Packaging_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số vật tư nhập lại phải lớn hơn 0 và không vượt ${i?.max}`)
};

/**

* @param {Sales_Return_Err_Packaging_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_packaging_qty = /** @type {((inputs: Sales_Return_Err_Packaging_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_Packaging_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_packaging_qty(inputs)
});